var swiper = new Swiper(".js-feature-expert", {
    slidesPerView: 1,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
    },
    breakpoints: {
        425: {
            slidesPerView: 1,
            spaceBetween: 20
        },
        490: {
            slidesPerView: 2,
            spaceBetween: 20
        },
        768: {
            slidesPerView: 2.9,
            spaceBetween: 13
        },
        840: {
            slidesPerView:3.1 ,
            spaceBetween: 16
        },
        1024: {
            slidesPerView: 3,
            spaceBetween: 16
        },
        1440: {
            slidesPerView: 4,
            spaceBetween: 16
        }
    }
});